import { ticketProps } from "@shared/components/tickets/constants";
import { type MachineRestrictionConfiguration } from "./machineRestrictions/config";
import { type ReportOverviewSettings } from "@shared/components/twinManagement/types";

export const ticketManagementPrefix = "tm.ticket.maintenance.*";

export const clientId = "smx-maintenance";

export const materialConsumptionId = "materialConsumption";

export const filterKeys = {
  responsibility: "maintenanceResponsibility",
};

export const maintenanceTicketProps = {
  ...ticketProps,
  asset: "asset",
  area: "area",
  responsibility: "responsibility",
  causeCategory: "causeCategory",
};

export const localStorageMachineRestrictionKey = "machineRestrictions";

export const machineRestrictionConfig: MachineRestrictionConfiguration = {
  clientId: clientId,
  detailRouteName: "tmMachineRestrictionsCreateEdit",
  overviewRouteName: "tmMachineRestrictions",
  createTwinRouteName: "tmCreateTicket",
  templateType: "tm.ticket.maintenance",
};

export const roles = {
  user: "user",
  admin: "admin",
  // NOTE: this is called planer with one n in the backend
  planner: "planer",
  ticketCreator: "ticket-creator",
};

export const maintenanceReportOverviewSettings: ReportOverviewSettings = {
  prefix: ticketManagementPrefix,
  reportOverview: {
    staticReports: [
      {
        route: { name: "tmReports" },
        title: "changelogs",
        adminOnly: true,
      },
      {
        route: { name: "tmMachineReports" },
        title: "maintenanceReports",
        adminOnly: true,
      },
    ],
    dynamicReportRouteName: "tmCustomReport",
  },
};
